<template>
  <div>
    <div class="systemSetup">
      <!-- top -->
      <div class="systemSetup-top">
        <div class="systemSetup-top-title">
          <span>系统设置</span>
          <!-- 提示帮助图标 -->
          <div class="attention">
            <div class="attention-model">
              <i></i>
              <ul>
                <li>
                  <p>当“优惠价格设定”的状态处于[进行中]时，则客服系统中的坐席单价执行对应设定好的价格；
                  </p>
                </li>
                <li>
                  <p>当“优惠价格设定”的状态处于[进行中]或[已完结]时，则客服系统中的坐席单价执行日常设定好的价格。
                  </p>
                </li>

              </ul>
            </div>
          </div>
        </div>

      </div>
      <!-- bottom -->
      <div class="systemSetup-bottom">
        <!-- 优惠价格设定 -->
        <div class="PreferentialPriceSetting">
          <div class="pps-content">
            <div class="pps-content-title">优惠价格设定</div>
            <div class="pps-content-form">
              <label>价格 :
                <el-input @change="validationMathPreferential" v-model="PreferentialPriceIptVal" :disabled="disabledPreferential" class="price"></el-input> 元/每座席每年
              </label>
              <label>优惠时间 :
                <el-date-picker 
                :disabled="disabledPreferential" 
                @change="datetimerangemd" 
                class="datetimerange" 
                v-model="DateTimeValue" 
                type="datetimerange" 
                :placeholder="DateTimeplaceHolder">
                </el-date-picker>

              </label>
              <label>状态 :
                <span class="PreferentialStatus">{{PreferentialStatusShow}}</span>
              </label>
            </div>
          </div>
          <!-- 优惠价格按钮 -->
          <div class="pps-btn">
            
            <!-- 进行中按钮 -->
            <div v-if="disabledBtn == 1" @click="statusChangePreferential">
              <div class="showPreferential"></div>
            </div>
            <!-- 未设定按钮 -->
            <div v-else-if="disabledBtn == 2" class="btnPicActive">
              <el-button type="text" @click="statusChangePreferentialNoSeting"></el-button>
            </div>
            <!-- 已完结按钮 -->
            <div v-else-if="disabledBtn == 3" @click="statusChangePreferentialOverEnd">
              <div class="overEnd"></div>
            </div>
          </div>

        </div>
        <!-- 日常价格设定 -->
        <div class="DailyPriceSetting">
          <div class="pps-content">
            <div class="pps-content-title">日常价格设定</div>
            <div class="pps-content-form">
              <label>价格 :
                <el-input :disabled="disabledDaily" @change="validationMathDaily" v-model="DailyPriceIptVal" class="price"></el-input> 元/每座席每年
              </label>
              <label>执行时间 :
                <span class="Daily">日常</span>

              </label>
              <label>状态 :
                <span class="DailyStatus">{{DailyStatusShow}}</span>
              </label>
            </div>
          </div>
          <!-- 日常价格按钮 -->
          <div class="pps-btn">
            <div v-if="disabledDaily" @click="statusChangeDailyNoSeting">
              <div class="edit"></div>
            </div>
            <div v-if="!disabledDaily" @click="statusChangeDailyEdit">
              <div class="DailyPitch"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@function p2r($size) {
  @return $size/16*1rem;
}

* {
  box-sizing: border-box;
  font-size: 14px;
}

// top部分
.systemSetup-top {
  display: flex;
  justify-content: space-between;
  height: 70px; // top的左边标题
  .systemSetup-top-title {
    padding-left: p2r(18);
    height: 100%;
    position: relative;
    span {
      display: inline-block;
      padding-top: 23px;
      font-size: 18px;
      color: #666;
    }
    .attention {
      position: absolute;
      top: 28px;
      right: -26px;
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url("../../statics/img/icon@2x.png") no-repeat 0 -729px;
      .attention-model {
        position: absolute;
        width: 500px;
        top: -20px;
        left: 50px;
        z-index: 2;
        background: rgba(0, 0, 0, .8);
        padding: 15px;
        box-sizing: border-box;
        border-radius: 10px;
        display: none;
        i {
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 12px solid transparent;
          border-right: 24px solid rgba(0, 0, 0, .8);
          border-bottom: 12px solid transparent;
          position: absolute;
          left: -24px;
          top: 17px;
        }
        ul {
          li {
            margin-bottom: 20px;
            p {
              color: #fff;
              padding: 10px;
              font-size: 14px;
              height: 30px;
            }
          }
        }
      }
      &:hover {
        .attention-model {
          display: block;
        }
      }
    }
  }
}

// bottom部分
.systemSetup-bottom {
  // position:relative;
  //优惠价格设定&日常价格设定
  .PreferentialPriceSetting,
  .DailyPriceSetting {
    display: flex;
    border: 1px solid #e0e1e3;
    height: 215px;
    width: 800px;
    padding-left: 45px;
    box-sizing: border-box;
    .pps-content {
      flex: 1;
      .pps-content-title {
        padding-top: 24px;
        font-size: 14px;
        color: #333;
      } // input
      .pps-content-form {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        label {
          color: #65657a;
          .promptError {
            padding-left: 10px;
          }
        }
        .price {
          width: 120px;
          height: 36px;
          border-radius: 5px;
          padding-left: 7px;
          margin-right: 10px;
        }
        .datetimerange {
          margin-top: 20px;
          padding-left: 7px;
        }
        .PreferentialStatus,
        .DailyStatus {
          display: inline-block;
          margin-top: 20px;
        } //日常价格的优惠时间
        .Daily {
          margin-top: 25px;
          padding-left: 7px;
          display: inline-block;
        }
      }
    } // 右侧按钮
    .pps-btn {
      height: 100%;
      background: #fcfcfc;
      width: 218px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-left: 1px solid #e0e1e3;
      cursor: pointer;
      >div {
        width:100%;
        height:100%;
        display: flex;
        justify-content: center;
        align-items:center;
        .showPreferential {
          height: 26px;
          width: 26px;
          background: url("../../statics/img/icon@2x.png") no-repeat -111px -1031px;
        }

        &.btnPicActive {
          height: 26px;
          width: 26px;
          background: url("../../statics/img/icon@2x.png") no-repeat 0 -1032px;
          position: relative;
          button {
            position: absolute;
            display: inline-block;
            height: 210px;
            width: 218px;
            top: -92px;
            left: -97px;
          }
        }
        .overEnd {
            height: 33px;
            width: 32px;
            background: url("../../statics/img/icon@2x.png") no-repeat -1px -1119px;
        } 
      }
    }
  } // 日常价格设定
  .DailyPriceSetting {
    margin-top: 20px;
    .pps-btn {
      >div {
        .edit {
          height: 33px;
          width: 32px;
          background: url("../../statics/img/icon@2x.png") no-repeat -1px -1119px;
        }
        .DailyPitch {
          height: 26px;
          width: 26px;
          background: url("../../statics/img/icon@2x.png") no-repeat -111px -1031px;
        }
      }
    }
  }
}
</style>

<script>
import qs from 'qs';

export default {
  data() {
    return {
      inputtest:1,
      // 绑定日期时间选择器
      DateTimeValue: "",
      //设置日期时间选择器的placeholder
      DateTimeplaceHolder: "生效时间 - 到期时间",
      // 绑定优惠价格的value
      PreferentialPriceIptVal: '',
      // 绑定日常价格的value
      DailyPriceIptVal: '',
      // 优惠 状态的显示
      PreferentialStatusShow: "未设定",
      //禁用优惠设定的input
      disabledPreferential: false,
      //优惠价格按钮的显示
      disabledBtn:1,
      //获取优惠价格获取到的数据
      discountPriceData: {},
      // 日常 状态的显示
      disabledDaily: true,
      // 日常 状态的显示
      DailyStatusShow: "进行中",
      //价格列表数据
      priceListData:{},
      //日期选择器的初始和结尾时间
      startTime:"",
      endTime:"",
      dailyPriceDefault:""

    }
  },
  created() {
    this.getPrice();
    channel.push("subscribe", "system_manage");
    channel.off("seat_discount_state");
    channel.on("seat_discount_state", payload => {
      //  判断状态是否 已完结
      if(payload.state == 2) {
        this.PreferentialStatusShow = "已完结";
        this.disabledBtn = 3;
      }else if(payload.state == 1) {
        this.PreferentialStatusShow = "进行中";
        this.disabledBtn = 2;
      }
    });
  },
  destroyed() {
    channel.push("unsubscribe", "system_manage")
  },
  methods: {
    // 验证 优惠价格input
    validationMathPreferential(val) {

      setTimeout(()=> {
            //先把非数字的都替换掉，除了数字和.  
            this.PreferentialPriceIptVal = this.PreferentialPriceIptVal.replace(/[^\d.]/g,"");  
            //保证只有出现一个.而没有多个.  
            this.PreferentialPriceIptVal = this.PreferentialPriceIptVal.replace(/\.{2,}/g,".");  
            //保证.只出现一次，而不能出现两次以上  
            this.PreferentialPriceIptVal = this.PreferentialPriceIptVal.replace(".","$#$").replace(/\./g,"").replace("$#$",".");  
            this.PreferentialPriceIptVal = this.PreferentialPriceIptVal.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); //只能输入两个小数  
            if(this.PreferentialPriceIptVal.indexOf(".")< 0 && this.PreferentialPriceIptVal !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
                this.PreferentialPriceIptVal= parseFloat(this.PreferentialPriceIptVal); 
            }
       },100)
            
        //console.log(this.PreferentialPriceIptVal);

    },
    // 验证 日常价格input
    validationMathDaily() {
      setTimeout( () => {
          //先把非数字的都替换掉，除了数字和.  
          this.DailyPriceIptVal = this.DailyPriceIptVal.replace(/[^\d.]/g,"");  
          //保证只有出现一个.而没有多个.  
          this.DailyPriceIptVal = this.DailyPriceIptVal.replace(/\.{2,}/g,".");  
          //保证.只出现一次，而不能出现两次以上  
          this.DailyPriceIptVal = this.DailyPriceIptVal.replace(".","$#$").replace(/\./g,"").replace("$#$",".");  
          this.DailyPriceIptVal = this.DailyPriceIptVal.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); //只能输入两个小数  
          if(this.DailyPriceIptVal.indexOf(".")< 0 && this.DailyPriceIptVal !=""){//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
              this.DailyPriceIptVal= parseFloat(this.DailyPriceIptVal); 
          }  
      },100)
      
        //console.log(this.DailyPriceIptVal);

    },
     // 获取价格列表
    getPrice() {
      this.$ajax.post(
        "/api/get_price_list",
        qs.stringify({
          price: this.PreferentialPriceIptVal
        })
      ).then(res => {
        console.log("获取价格数据列表",res);
        this.priceListData = res.data.data.price_list;
        this.dailyPriceDefault = res.data.data.default_price;
        //优惠价格的状态判断
        if(this.priceListData[1] && this.priceListData[1].type == 2) {
           this.PreferentialPriceIptVal = this.priceListData[1].price;
           this.disabledPreferential = true;
           this.PreferentialStatusShow = "进行中";
           this.DateTimeplaceHolder = this.priceListData[1].started_at + " - " + this.priceListData[1].ended_at;
          //  判断状态是否 已完结
          if(this.priceListData[1].state == 2) {
           this.PreferentialStatusShow = "已完结";
           this.disabledBtn = 3;
            // console.log("已完结");
          }else if(this.priceListData[1].state == 1) {
            //  判断状态是否 进行中
            this.disabledBtn = 2;
          }
        }

        //日常价格的状态判断
        if(this.priceListData[0] && this.priceListData[0].type == 1) {
            this.DailyPriceIptVal = this.priceListData[0].price || "请输入日常价格";
        }
      })
    },
    //切换到优惠价格状态-未设定 => 进行中
    statusChangePreferential() {
      console.log("查看placeholder日期",this.DateTimeplaceHolder);
      if(this.DateTimeplaceHolder != "生效时间 - 到期时间") {
        this.startTime = this.DateTimeplaceHolder.split(" - ")[0];
        this.endTime = this.DateTimeplaceHolder.split(" - ")[1];
        console.log("查看placeholder日期，分开",this.startTime,this.endTime)
      }

      
      if (this.PreferentialPriceIptVal && (this.DateTimeValue[0] || this.startTime) ) {
        // 调用优惠价格-设定api
        console.log("ojkoko");
        this.$ajax.post(
          "/api/set_discount_price",
          qs.stringify({
            price: this.PreferentialPriceIptVal,
            started_at: this.DateTimeValue[0] || this.startTime,
            ended_at: this.DateTimeValue[1] || this.endTime
          })
        ).then(res => {
          console.log("优惠价格",res);
          this.discountPriceData = res.data.data;
          this.disabledBtn = 2;
          this.PreferentialStatusShow = "进行中";
          this.disabledPreferential = true;
        })
      }
    },
    //切换到优惠价格状态-已完结 => 未设定
    statusChangePreferentialOverEnd() {
      //恢复默认input和状态栏默认设置
      this.PreferentialStatusShow = "未设定";
      this.disabledPreferential = false;
      this.disabledBtn = 1;
      //优惠价格-删除
      this.$ajax.post(
        "/api/delete_discount_price",
        qs.stringify({
          id:this.discountPriceData.id || this.priceListData[1].id
        })
      ).then(res => {
        // console.log(res);
      })

    },
    // 切换到优惠价格状态-进行中 => 未设定&模态框设置
    statusChangePreferentialNoSeting() {
      const h = this.$createElement;
      this.$msgbox({
        message: h('p', null, [
          h('h3', { style: 'text-align:center' }, '提示!'),
          h('span', null, '是否要终止当前正在进行中的优惠价格设定 ？'),
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';
            setTimeout(() => {
              done();
              setTimeout(() => {
                instance.confirmButtonLoading = false;

                //恢复默认input和状态栏默认设置
                this.PreferentialStatusShow = "未设定";
                this.disabledPreferential = false;
                this.disabledBtn = 1;
                //优惠价格-删除
                this.$ajax.post(
                  "/api/delete_discount_price",
                  qs.stringify({
                    id:this.discountPriceData.id || this.priceListData[1].id
                  })
                ).then(res => {
                  // console.log(res);
                    //同时调用日常价格
                    //日常价格设定
                    this.$ajax.post(
                      "/api/set_general_price",
                      qs.stringify({
                        price: this.DailyPriceIptVal
                      })
                    ).then(resDaily => {
                      console.log("日常价格开启123",resDaily);
                      console.log("价格DailyPriceIptVal",this.DailyPriceIptVal)
                    })
                })

                
              }, 300);
            }, 500);
          } else {
            done();
          }
        }
      }).then(action => {
      });
    },
    //切换到日常价格状态-进行中 => 未设定
    statusChangeDailyNoSeting() {
      this.disabledDaily = false;
      this.DailyStatusShow = "未设定";
      this.DailyPriceIptVal = "";

    },
    //切换到日常价格状态-未设定 => 进行中
    statusChangeDailyEdit() {
      if(this.DailyPriceIptVal) {
        this.disabledDaily = true;
        this.DailyStatusShow = "进行中";

         //日常价格设定
          this.$ajax.post(
            "/api/set_general_price",
            qs.stringify({
              price: this.DailyPriceIptVal
            })
          ).then(res => {
            //console.log(res);
          })
      }else if(this.DailyPriceIptVal == "") {
        this.disabledDaily = true;
        this.DailyStatusShow = "进行中";

         //日常价格设定
          this.$ajax.post(
            "/api/set_general_price",
            qs.stringify({
              price: this.dailyPriceDefault
            })
          ).then(res => {
            //console.log(res);
            console.log("日常价格默认",this.dailyPriceDefault);
            this.DailyPriceIptVal = this.dailyPriceDefault;
          })
      }
    },
    //转换格式日期时间格式
    datetimerangemd(val) {
      if(val) {
        this.DateTimeValue[0] = val.split(" - ")[0];
        this.DateTimeValue[1] = val.split(" - ")[1];
      }

    }
  }
}

</script>



// WEBPACK FOOTER //
// systemSetup.vue?384f3e33